import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    ClientName: {
      validations: []
    },
    TelNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    Email: {
      validations: [
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    Theme: {
      validations: []
    },
    EventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future.' }
      ]
    },
    SiteName: {
      validations: []
    },
    Notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Name',
            mapping: 'ClientName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number',
            mapping: 'TelNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email',
            mapping: 'Email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Type of Event',
            mapping: 'Theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker-nofill',
            size: 'Medium',
            label: 'Date of Event',
            mapping: 'EventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Location of Event',
            mapping: 'SiteName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Additional Info:',
            mapping: 'Notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Chic Chef Catering Contact Form',
    formId: '599',
    clientKey: 'BB0BF4D3-AC46-4A77-84DE-5CB4B56B456B',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/chicchefcatering/form_structure.js